import xor from 'lodash-es/xor'
import without from 'lodash-es/without'
import { createReducer } from '../../util'
import { Action } from 'redux'

export const ADD_PLAYER: string = 'Teams/ADD_PLAYER'
export const REMOVE_PLAYER: string = 'Teams/REMOVE_PLAYER'
export const TOGGLE_PLAYER: string = 'Teams/TOGGLE_PLAYER'

type ModifyTeamAction = Action & {
  matchId: string
  playerId: string
}

type AddPlayerAction = ModifyTeamAction
type RemovePlayerAction = ModifyTeamAction
type TogglePlayerAction = ModifyTeamAction

export const addPlayer = (matchId: string, playerId: string): AddPlayerAction => ({
  type: ADD_PLAYER,
  matchId,
  playerId
})

export const removePlayer = (matchId: string, playerId: string): RemovePlayerAction => ({
  type: REMOVE_PLAYER,
  matchId,
  playerId
})

export const togglePlayer = (matchId: string, playerId: string): TogglePlayerAction => ({
  type: TOGGLE_PLAYER,
  matchId,
  playerId
})

const ACTION_HANDLERS = {
  [ADD_PLAYER]: (state: TeamsState, { matchId, playerId }: AddPlayerAction) => ({
    ...state,
    [matchId]: [...state[matchId] || [], playerId]
  }),
  [REMOVE_PLAYER]: (state: TeamsState, { matchId, playerId }: RemovePlayerAction) => ({
    ...state,
    [matchId]: without(state[matchId], playerId)
  }),
  [TOGGLE_PLAYER]: (state: TeamsState, { matchId, playerId }: TogglePlayerAction) => ({
    ...state,
    [matchId]: xor(state[matchId], [playerId])
  })
}

type TeamsByMatchId = {
  readonly [matchId: string]: string[]
}

export type TeamsState = TeamsByMatchId

const initialState: TeamsState = {
}

// TODO: Ezzel is kéne kezdeni valamit...
export default createReducer(initialState, ACTION_HANDLERS as unknown as {})
